module.exports = __webpack_public_path__ + "img/rediger.6f73af06.svg";